import { render } from "./examReport.vue?vue&type=template&id=50d89eb3"
import script from "./examReport.vue?vue&type=script&lang=js"
export * from "./examReport.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__